import React, { createContext, useState, ReactNode, useEffect } from 'react';

interface LoadGeneralContextProps {
	isOpenLoad: boolean;
	setIsOpenLoad: React.Dispatch<React.SetStateAction<boolean>>;
	message: string;
	setMessage: React.Dispatch<React.SetStateAction<string>>;
	color: string | null;
	setColor: React.Dispatch<React.SetStateAction<string | null>>;
}

const LoadGeneralContext = createContext<LoadGeneralContextProps>({
	isOpenLoad: false,
	setIsOpenLoad: () => {},
	message: '',
	setMessage: () => {},
	color: null,
	setColor: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function LoadGeneralProvider({ children }: ContextProps) {
	const [isOpenLoad, setIsOpenLoad] = useState(false);
	const [message, setMessage] = useState('');
	const [color, setColor] = useState<string | null>(null);

	useEffect(() => {
		if (!isOpenLoad) {
			setMessage('');
			setColor(null);
		}
	}, [isOpenLoad]);

	return (
		<LoadGeneralContext.Provider
			value={{
				isOpenLoad,
				setIsOpenLoad,
				message,
				setMessage,
				color,
				setColor
			}}
		>
			{children}
		</LoadGeneralContext.Provider>
	);
}

export default LoadGeneralContext;
